var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgIconX = function SvgIconX(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 10 10",
    strokeWidth: 0,
    className: "icon__x_svg__x"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "M8.3.757 5 4.057 1.7.757a.667.667 0 0 0-.943.943l3.3 3.3-3.3 3.3a.667.667 0 0 0 .943.943l3.3-3.3 3.3 3.3a.667.667 0 0 0 .943-.943L5.943 5l3.3-3.3A.667.667 0 0 0 8.3.757"
  })));
};
export { SvgIconX as ReactComponent };
export default "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHZpZXdCb3g9IjAgMCAxMCAxMCIgc3Ryb2tlLXdpZHRoPSIwIiBjbGFzcz0ieCI+CiAgICA8cGF0aCBmaWxsPSIjMDAwIiBmaWxsLXJ1bGU9ImV2ZW5vZGQiCiAgICAgICAgICBkPSJNOC4zLjc1N0w1IDQuMDU3IDEuNy43NTdhLjY2Ny42NjcgMCAwIDAtLjk0My45NDNsMy4zIDMuMy0zLjMgMy4zYS42NjcuNjY3IDAgMCAwIC45NDMuOTQzbDMuMy0zLjMgMy4zIDMuM2EuNjY3LjY2NyAwIDAgMCAuOTQzLS45NDNMNS45NDMgNWwzLjMtMy4zQS42NjcuNjY3IDAgMCAwIDguMy43NTciLz4KPC9zdmc+Cg==";